export default __webpack_public_path__ + "static/lb-14-1edb24a36c8c826638891819a73893c8.webp";